<template>
  <v-navigation-drawer id="userNavigator" fixed app
    v-model="config.status.active"
    :clipped="$vuetify.breakpoint.lgAndUp">
    <v-list dense>
      <template v-for="item in authedNavigation">
        <v-list-tile :key="item.path" :to="item.path" :class="item.active ? 'blue--text text--darken-2' : ''">
          <v-list-tile-avatar>
            <font-awesome-icon :icon="item.active ? item.meta.icon.active : item.meta.icon.default"></font-awesome-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.meta.label }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </template>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import UserRoutes from '@/router/user'
export default {
  name: 'userNavigator',
  components: {
  },
  data () {
    return {
      config: {
        status: {
          active: true
        },
        logo: require('@/assets/logo.png')
      }
    }
  },
  created () {
  },
  methods: {
    toggle: function () {
      this.$set(this.config.status, 'active', !this.config.status.active)
    }
  },
  computed: {
    authedNavigation () {
      let matches = this.$route.matched.map(it => it.name)
      return UserRoutes.routes.map(it => {
        return Object.assign({}, it, {
          active: matches.includes(it.name),
          path: `/u/${it.path}`
        })
      })
    }
  }
}
</script>

<style lang="scss">
</style>
